export default __webpack_public_path__ + "static/media/AllProductFilterUpArrow.e14dd8e6.svg";